import type { PayGateApi } from '@env0/common-pay-gate/api';
import { useGetBillingInformation } from 'stores/rq/billing';

export const usePayGateFeature = (featureName: PayGateApi.FeatureName) => {
  const { isLoading, data } = useGetBillingInformation();

  const activated = Boolean((data?.[featureName] as PayGateApi.BooleanPayGateValue)?.activated);

  return {
    payGateTitleId: activated || isLoading ? '' : 'paygate.feature.disabled',
    activated,
    isLoading
  };
};
